import lionden_2 from "../assests/lionden_2.jpg";
import lionden_1 from "../assests/lionden_1.jpg";
import connectMe_1 from "../assests/connectMe_1.jpg";
import catfeeder_1 from "../assests/catfeeder.jpg";
import catfeeder_2 from "../assests/catfeeder_2.jpg";
import thriftstore_1 from "../assests/thriftstore_1.jpg";
import thriftstore_2 from "../assests/thriftstore_2.jpg";
import discord from "../assests/discord_project.png";
import textify from "../assests/textify.png"
import npm from "../assests/npm.png"
import faqbot from "../assests/faqbot.png"
import instarelief from "../assests/insta-relief.png"

const projects = [
  {
    id: "p1",
    title: "Semantic Search Engine",
    role: "Full Stack + AI Engineer",
    institution: "Southeastern Louisiana University",
    startDate: "May 2025",
    endDate: "Present",
    status: "In Progress",
    description:
      "A full-stack semantic PDF search and Q&A platform enabling contextual question answering from indexed PDF manuscripts.",
    techStack: [
      "FastAPI",
      "FAISS",
      "SentenceTransformers",
      "Python",
      "React",
      "LLMs (Mistral, Ollama)",
      "Docker",
    ],
    highlights: [
      "Cosine similarity search over vector embeddings with semantic chunk alignment",
      "Dynamic in-PDF highlighting using react-pdf highlighter",
      "Local LLM generation fallback to reduce cloud costs",
    ],
    url: "https://blogs-8329e.web.app/blogs/DohboiDCwVqJbdyPTLEc",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/blogs-8329e.appspot.com/o/images%2FSemantic%20Search2.png?alt=media&token=85e133ab-0605-4b9b-9535-e68e0a314d20",
    ],
  },
  {
  id: "p2",
  title: "Nepali Profanity Checker",
  role: "Full Stack + Library Developer",
  startDate: "Sep 2024",
  endDate: "Oct 2024",
  description:
    "An open-source TypeScript library that detects and censors Nepali profanity in both Devanagari and romanized text.",
  techStack: [
    "TypeScript",
    "Node.js",
    "Jest",
    "GitHub Actions",
    "npm",
  ],
  tags: [
    "TypeScript",
    "NLP",
  ],
  highlights: [
    "Implemented Unicode normalization and diacritic stripping for accurate text matching",
    "Added optional fuzzy-matching mode (Levenshtein) to detect obfuscated profanity variants",
    "Developed safe censor algorithm preserving Unicode string length",
    "Wrote comprehensive unit and edge tests with Jest and automated CI via GitHub Actions",
    "Published and documented package on npm for community use",
  ],
  url: "https://www.npmjs.com/package/nepali-profanity-checker",
  images: [npm],
},

  {
    id: "p3",
    title: "FAQBot AI Chat Support Widget",
    role: "Lead Full Stack & AI Developer",
    startDate: "March 2025",
    endDate: "Present",
    status: "In Progress",
    description:
      "A multi-tenant AI chatbot widget that handles customer FAQs with automatic analytics and content control.",
    techStack: [
      "Next.js",
      "React",
      "Firebase",
      "Vertex AI",
      "Google Cloud",
      "RAG Pipeline",
    ],
    highlights: [
      "30% reduction in unanswered queries with custom embeddings",
      "Admin dashboard for usage analytics and brand customization",
      "CI/CD deployment automation with secure authentication",
    ],
    url: "https://faq-flow-chatbot.netlify.app/login",
    images: [faqbot],
  },
  {
    id: "p4",
    title: "Lion's Den Theater App",
    role: "Full Stack Developer",
    institution: "Southeastern Louisiana University",
    startDate: "Jan 2025",
    endDate: "May 2025",
    description:
      "Led the development of a full-stack theater ticket booking platform for web and mobile using React (TypeScript), React Native, and ASP.NET Core. ",
    techStack: [
      "React",
      "React Native",
      "TypeScript",
      "Tailwind CSS",
      "ASP.NET Core",
      "C#",
      "SQL Server",
      "Stripe",
      "Azure",
    ],
     tags: [
      "React",
      "React Native",
      "TypeScript",
      "Tailwind CSS",
      "ASP.NET Core",
      "C#",
      "SQL Server",
      "Stripe",
      "Azure",
    ],
    highlights: [
      "Developed real-time booking and payment flow using Stripe API",
      "Built GPS-based theater locator and mobile-first UX",
      "Implemented CI/CD with GitHub Actions and Azure deployment",
      "Used Jira for Agile sprint management and automated testing",
      "Created admin dashboard with analytics and role-based access control",
    ],
    url: "https://github.com/Subeen9/cmps383-2025-sp-p03-cmps383-2025-sp-p03-g01",
    images: [lionden_2, lionden_1],
  },
    {
  id: "p6",
  title: "InstaRelief",
  role: "Full Stack, AI & Web3 Developer",
  institution: "Hack NYU",
  startDate: "Mar 2024",
  endDate: "Mar 2024",
  description:
    "InstaRelief is a prototype parametric micro-insurance platform that detects NOAA weather alerts, pre-credits impacted users, and enables administrators to execute audited Solana (SOL) payouts via Phantom. It demonstrates an automated disaster-relief workflow using Firebase, Cloud Functions, and a lightweight AI assistant.",
  techStack: [
    "React",
    "Vite",
    "MUI",
    "Firebase Auth",
    "Firestore",
    "Cloud Functions",
    "Solana Web3",
    "NOAA API",
    "SMTP2GO",
    "Leaflet",
    "Node.js"
  ],
  tags: [
    "React",
    "Firebase",
    "Solana Web3",
    "Cloud Functions",
    "NOAA Alerts"
  ],
  highlights: [
    "Built automated NOAA alert ingestion using Firebase Cloud Functions with real-time user impact detection",
    "Implemented pre-crediting workflow that updates user balances instantly for demo payouts",
    "Developed Solana devnet payout system using Phantom wallet integration and on-chain SOL transfers",
    "Created an admin dashboard with an AI assistant to summarize events and prepare payout actions",
    "Designed map-based NOAA alert visualization using Leaflet for situational awareness",
    "Integrated SMTP2GO to notify users about disaster triggers and payout statuses"
  ],
  images: [instarelief],
  url: "https://devpost.com/software/instarelief"
},
   {
    id: "p5",
    title: "Textify – Digital Humanities Platform",
    role: "Full Stack & AI Developer",
    institution: "HackHarvard",
    startDate: "Jan 2024",
    endDate: "May 2024",
    description:
      "Textify is a digital humanities platform designed to enhance the study of ancient literature and culture. The project digitizes manuscripts in Old English, Latin, Greek, and Sanskrit, using Google Cloud Vision for OCR and advanced computer vision techniques to structure the documents.",
    techStack: [
      "React",
      "Next.js",
      "FastAPI",
      "Python",
      "Google Cloud Vision",
      "Google TTS",
      "CLTK",
      "Gemini Flash 1.5",
    ],
    tags:[ "React",
      "Next.js",
      "FastAPI",
      "Python",
      "Google Cloud Vision"],
    highlights: [
      "Digitized and structured ancient manuscripts across multiple classical languages",
      "Achieved 90–95% text accuracy using Gemini Flash 1.5 and computer vision",
      "Performed lexical analysis with CLTK and generated live English audio with Google TTS",
      "Streamlined transcription process for scholars, reducing years of manual effort",
      "Full-stack architecture: React/Next.js frontend with FastAPI backend",
    ],
    images: [textify],
    url: "https://devpost.com/software/textify-2jq4fi",
  },
  {
    id: "p9",
    title: "ConnectMe Digital Business Card App",
    role: "Mobile Developer",
    startDate: "Aug 2024",
    endDate: "Oct 2024",
    description:
      "ConnectMe is a digital business card generator designed to modernize and simplify professional networking. Built using the Flutter framework, it enables users to create customizable and shareable digital cards that can be exchanged instantly via QR codes.",
    techStack: ["Flutter", "Dart", "Firebase", "Android", "iOS", "Native APIs"],
     tags: [
      "Flutter"
    ],
    highlights: [
      "Generated personalized digital cards with customizable templates",
      "Implemented QR-based sharing for instant contact exchange",
      "Enabled offline access with local data storage using Firebase",
      "Delivered eco-friendly, cross-platform networking experience",
      "Published a Research Journel on IJMER",
    ],
    url: "https://www.ijmer.com/papers/Vol14_issue6/1406106111.pdf",
    images: [connectMe_1],
  },
  {
    id: "p7",
    title: "Automated IoT Pet Feeder",
    role: "Backend + Embedded Developer",
    startDate: "Nov 2023",
    endDate: "Dec 2023",
    description:
      "An IoT-based smart pet feeder controlled through voice commands or scheduling.",
    techStack: [
      "Python",
      "Raspberry Pi",
      "SQLite",
      "Flask",
      "Speech Recognition",
      "Google TTS",
    ],
     tags: [
      "Python",
    ],
    highlights: [
      "Voice-controlled and scheduled feeding using Raspberry Pi",
      "Developed Flask-based dashboard with feed history analytics",
      "Integrated hardware and backend for seamless automation",
      "Led team coordination and milestone-driven development",
    ],
    url: "https://github.com/Subeen9/Pao-Pao-Cat-feeder",
    images: [catfeeder_1, catfeeder_2],
  },
  {
    id: "p8",
    title: "JobFinder Discord Bot",
    role: "Full Stack & Bot Developer",
    startDate: "Sep 2024",
    endDate: "Oct 2024",
    description:
      "Developed a Discord bot that fetches the latest job and internship listings using the Adzuna Job Search API. Users can search for opportunities by field and location, and the bot automatically posts new job updates to a designated Discord channel every 6 hours, streamlining job discovery for communities.",
    techStack: [
      "Python",
      "Discord SDK",
      "Adzuna API",
      "Cron Jobs",
      "REST APIs",
    ],
     tags: [
      "Python",
    ],
    highlights: [
      "Automated job/internship updates posted every 6 hours",
      "Searchable listings by field and location via Discord commands",
      "Integrated Adzuna API for real-time job data retrieval",
      "Enhanced community engagement through instant notifications",
    ],
    images: [discord],
    url: "https://github.com/SilvinPradhan/job-listing-nsas",
  },

  {
    id: "p10",
    title: "Selu Thrift Store",
    role: "Full Stack Developer",
    institution: "Southeastern Louisiana University",
    startDate: "Sept 2023",
    endDate: "May 2024",
    description:
      "A buying and selling platform tailored for SELU students with secure payments and inventory management.",
    techStack: [
      "React",
      "TypeScript",
      "ASP.NET Core",
      "Entity Framework",
      "SQL Server",
      "Mantine UI",
      "Stripe",
      "Azure",
    ],
    tags:[ "React"],
    highlights: [
      "Unified buyer and seller profiles",
      "Secure Stripe-based checkout",
      "Version control and teamwork with Agile sprints",
    ],
    images: [thriftstore_1, thriftstore_2],
  },


  
];

export default projects;
